<template>
  <div>
    <div class="find-doctor-page">
      <div class="header">
        <button class="back-button" @click="goBack">
          <i class="pi pi-chevron-left"></i>
        </button>
        <div class="w-100">
          <h3 class="page-title text-center pt-3" style="line-height: 1">
            Запись на прием
          </h3>
          <p class="page-subtitle text-center" style="line-height: 1">
            выберите врача
          </p>
        </div>
      </div>

      <div class="doctor-list pt-3">
        <DoctorCard
          class="mb-2"
          v-for="doctor in doctors"
          :key="doctor.id"
          :doctor="doctor"
          @click="goToDetails(doctor.id)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import DoctorCard from "@/components/DoctorCard.vue";
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "DoctorsPage",

  components: { DoctorCard },
  setup() {
    const router = useRouter();

    const goBack = () => {
      router.push({ name: "HomeView" });
    };

    const doctors = [
      {
        id: 1,
        name: "Чащин\nМихаил Георгиевич",
        specialty: "Заведующий отделением, кардиолог-липидолог",
        scstatus: "к.м.н.",
        reviews: 120,
        experience: 10,
        patients: 1000,
        rating: 4.5,
        image: require("@/assets/MCH.jpg"),
      },
      {
        id: 2,
        name: "Глечян\nАнуш Михайловна",
        specialty: "Кардиолог-липидолог",
        scstatus: "к.м.н.",
        reviews: 85,
        experience: 12,
        patients: 1100,
        rating: 4.0,
        image: require("@/assets/GL.jpg"),
      },
      {
        id: 3,
        name: "Емельянов\nАлександр Владимирович",
        specialty: "Кардиолог-липидолог",
        scstatus: "высшая категория",
        reviews: 120,
        experience: 30,
        patients: 900,
        rating: 4.04,

        image: require("@/assets/EM.jpg"),
      },
    ];

    const goToDetails = (id: number) => {
      router.push({ name: "DoctorProfilePage", params: { id } });
    };

    return { doctors, goToDetails, goBack };
  },
});
</script>

<style scoped>
.find-doctor-page {
  padding: 16px;
  padding-top: 70px; /* Учитываем высоту header + отступ */
  background-color: #f9f9f9;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px; /* Устанавливаем высоту */
  background-color: #f9f9f9; /* Цвет фона для видимости */
  position: fixed; /* Фиксируем header */
  top: 0; /* Устанавливаем сверху */
  left: 0;
  right: 0;
  z-index: 10; /* Чтобы header был поверх других элементов */
  padding: 0 16px; /* Добавляем отступы */
}

.back-button {
  position: relative;
  padding-left: 8px;
  margin-right: -30px;
  background: transparent;
  border: none;
  font-size: 20px;
  color: #4caf50;
  cursor: pointer;
}

.search-icon {
  font-size: 20px;
  color: #6b6b6b;
}

.page-title {
  font-size: 20px;
  font-weight: bold;
  margin: 0 0 8px;
}

.page-subtitle {
  font-size: 14px;
  color: #9e9e9e;
  margin: 0 0 16px;
}

.doctor-list {
  margin-bottom: 16px;
  overflow-y: auto;
}

.continue-button {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  background-color: #4caf50;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.continue-button i {
  margin-left: 8px;
}
</style>
